// Third-party
import React, { ReactNode } from 'react';
import Pastille from './Pastille';

interface Props {
  children?: ReactNode;
}

const RoundedPastille = ({ children }: Props) => <Pastille className="is-rounded">{children}</Pastille>;

export default RoundedPastille;
